import { render, staticRenderFns } from "./ProductionReceipt.vue?vue&type=template&id=6b16c7f9&"
import script from "./ProductionReceipt.vue?vue&type=script&lang=js&"
export * from "./ProductionReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports